export default __webpack_public_path__ + "static/dm-slide-f2d60326c4ae1df0451d0b69c376ea59.jpg";